// Apollo client for Pimcore public-content entry point where queries are cached by our backend
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { getGraphqlEndpoint } from '../../../utils/Pimcore';

const httpLinkCached = new HttpLink({
    uri: getGraphqlEndpoint({ direct: false, cached: true }),
});

const pimcoreClientCachedRequests = new ApolloClient({
    link: httpLinkCached,
    cache: new InMemoryCache(),
    ssrMode: typeof window === 'undefined',
    defaultOptions: {
        watchQuery: { fetchPolicy: 'no-cache' },
        query: { fetchPolicy: 'no-cache' },
    },
});

export default pimcoreClientCachedRequests;
